import {
  FestivalMainRankContent,
  FestivalMainRankListWrapper,
  FestivalMainRankWrapper,
} from "./style";
import RabbitFestivalRankTop3 from "./components/top3";
import RabbitFestivalRankItem from "./components/rank-item";
import { useRabbitFestivalRank } from "../../hooks/use-festival-rank";
import RabbitFestivalRankTop3Skeleton from "./components/top3/skeleton";
import { FestivalSkeletonGrayBox } from "../../../../style/skeleton";
import Pagination from "../../../../../../../components/web/Pagination";

const RabbitFestivalMainRank = () => {
  const {
    list,
    top3,
    totalPages,
    currentPage,
    setCurrentPage,
    isFirst,
    loading,
  } = useRabbitFestivalRank();

  return (
    <FestivalMainRankWrapper>
      <div className="title">순위</div>
      <FestivalMainRankContent>
        {isFirst ? (
          <RabbitFestivalRankTop3Skeleton />
        ) : (
          <RabbitFestivalRankTop3 top3={top3} />
        )}
        <FestivalMainRankListWrapper>
          {loading
            ? Array.from({ length: 6 }, (_, i) => (
                <FestivalSkeletonGrayBox key={i} width="100%" height="46px" />
              ))
            : list.map((item, i) => (
                <RabbitFestivalRankItem key={i} item={item} />
              ))}
        </FestivalMainRankListWrapper>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          size={22}
        />
      </FestivalMainRankContent>
    </FestivalMainRankWrapper>
  );
};

export default RabbitFestivalMainRank;
